/*
 *
 * XpayBackOfficePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 10-Apr-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.services.xpayBackOffice.popup.title'
      defaultMessage='Accedi a XPay Back-Office'
    />
  ),
  description: (
    <PortalMessage
      id='t.app.services.xpayBackOffice.popup.description'
      defaultMessage='<b>Per accedere, seleziona il punto vendita e il corrispettivo Terminal ID (TML).</b>'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.login'
      defaultMessage='Accedi'
    />
  ),
  labelPuntoVendita: (
    <PortalMessage
      id='t.app.shop.companyName'
      defaultMessage='Punto vendita'
    />
  ),
  placeholderPuntoVendita: (
    <PortalMessage
      id='t.app.services.xpayBackOffice.popup.placeholderPuntoVendita'
      defaultMessage='Seleziona punto vendita'
    />
  ),
  labelTerminal: (
    <PortalMessage
      id='t.app.services.xpayBackOffice.popup.labelTerminal'
      defaultMessage='Terminal ID (TML)'
    />
  ),
  placeholderTerminal: (
    <PortalMessage
      id='t.app.services.xpayBackOffice.popup.placeholderTerminal'
      defaultMessage='Seleziona terminal ID (TML)'
    />
  ),

  requiredError: (
    <PortalMessage
      id='t.app.error.requiredField'
      defaultMessage='Il campo è obbligatorio'
    />
  )
}

export default formattedMessage
